import script from "./DeptManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./DeptManagement.vue?vue&type=script&setup=true&lang=js"

import "./DeptManagement.vue?vue&type=style&index=0&id=25901de0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25901de0"]])

export default __exports__